import styled from 'styled-components';

export const SupressionRuleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export const SupressionRuleBreadcrumbContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
  margin-bottom: 16px;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-inline: 16px;
`; 